import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './CardField.less';

// reusable `CardField` component used on onboard flow
// only works with Redux Form Fields
// pass type as `checkbox` or `radio`
// pass cardType as `card-field`, `pill-field` or `icon-field`

class CardField extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: false,
    };
  }

  setActive(e) {
    const checkbox = e.target.type === 'checkbox';

    if (checkbox) {
      if (e.target.checked) {
        this.setState({
          active: true,
        });
      } else {
        this.setState({
          active: false,
        });
      }
    } else if (e.target.value) {
      this.setState({
        active: true,
      });
    }
  }

  render() {
    const {
      input,
      header,
      subText,
      id,
      type,
      disabled,
      handleOnClick,
      className,
      label,
      blurb,
      selectedValue,
      selectedCheck,
      subTextHtml,
      fallbackHeader,
      handleOnChange,
      cardType,
      meta,
      subTextInnerHtml,
    } = this.props;
    const { active } = this.state;
    const inputAttr = { ...input };
    const containerClassName = `${cardType}__container`;
    const showActiveCheckmark = active || selectedCheck;

    return (
      <div
        className={classNames(className, containerClassName, {
          'has-error': meta && meta.touched && meta.error,
        })}
      >
        <div className="zola-ui field-input">
          <input
            {...inputAttr}
            type={type}
            id={id}
            disabled={disabled}
            onChange={(e) => {
              input.onChange(e);
              this.setActive(e);
              if (handleOnChange) {
                setTimeout(() => handleOnChange(e));
              }
            }}
            onClick={(e) => {
              if (handleOnClick) {
                handleOnClick(e);
              }
            }}
          />
          <label
            htmlFor={id}
            className={classNames({ active: selectedValue, 'is-selected': showActiveCheckmark })}
          >
            {showActiveCheckmark && (
              <div className="checkmark-icon">
                <i className="zola-ui-icon zola-ui-icon-checkmark" />
              </div>
            )}
            {fallbackHeader && <span className="field-header">{fallbackHeader}</span>}
            {header && !fallbackHeader && <span className="field-header">{header}</span>}
            {subText && <span className="field-text">{subText}</span>}
            {subTextHtml && (
              // eslint-disable-next-line react/no-danger
              <span className="field-text" dangerouslySetInnerHTML={{ __html: `${subTextHtml}` }} />
            )}
            {subTextInnerHtml}
            {blurb && <span className="field-blurb">{blurb}</span>}
          </label>
          {label && <span className="field-label">{label}</span>}
        </div>
        {meta && meta.touched && meta.error && (
          <span className="help-block error-block">{meta.error}</span>
        )}
      </div>
    );
  }
}

CardField.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
  }).isRequired,
  id: PropTypes.string.isRequired,
  cardType: PropTypes.oneOf([
    'card-field',
    'card-field-lg card-field',
    'pill-field',
    'icon-field',
    'simple-card-field card-field',
    'simple-card-field-lg card-field',
  ]).isRequired,
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  fallbackHeader: PropTypes.string,
  type: PropTypes.oneOf(['checkbox', 'radio']).isRequired,
  subText: PropTypes.string,
  disabled: PropTypes.bool,
  active: PropTypes.bool,
  handleOnClick: PropTypes.func,
  handleOnChange: PropTypes.func,
  className: PropTypes.string,
  label: PropTypes.string,
  blurb: PropTypes.string,
  selectedValue: PropTypes.bool,
  selectedCheck: PropTypes.bool,
  /** Sringified html */
  subTextHtml: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  /** Allows for directly passing html to be rendered as sub-text  */
  subTextInnerHtml: PropTypes.node,
};

export default CardField;
